import { initReactI18next } from 'react-i18next/initReactI18next'
import i18next, { type i18n } from 'i18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import config from 'shared/config'

const languages = ['en']
const runsOnServerSide = typeof window === 'undefined'

export const initTranslations = (): i18n => {
  void i18next
    .use(initReactI18next)
    .use(
      resourcesToBackend(async (language: string, namespace: string) => {
        return await import(`../../public/locales/${language}/${namespace}.json`)
      })
    )
    .init({
      debug: config('I18N_DEBUG') as boolean,
      supportedLngs: languages,
      fallbackLng: 'en',
      defaultNS: 'common',
      lng: undefined,
      detection: {
        order: ['path', 'htmlTag', 'cookie', 'navigator']
      },
      preload: runsOnServerSide ? languages : []
    })
  return i18next
}
